import { param } from "jquery";
import axios from "../axios/index.js";

const initiatePayment = "/api/payment/initiate";
const successPayment = "/api/payment/complete";
const failurePayment = "/api/payment/failure";
const cancelPayment = "/api/payment/cancel";
const initiateShipping = "/api/fedex/prepare";

export default {
    initiatePayment(params) {
        return axios.post(initiatePayment, params);
    },

    initiateShipping(params) {
        return axios.post(initiateShipping, params);
    },

    paymentSuccess(params) {
        return axios.post(successPayment, params);
    },

    paymentFailure(params) {
        return axios.post(failurePayment, params);
    },

    paymentCancel(params) {
        return axios.post(cancelPayment, params);
    }
};
